import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import AlignTextLeftIcon from '@atlaskit/icon/core/align-text-left';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-all-fields-action-renderer.ui.action-card.rich-text-field.icon-label',
		defaultMessage: 'Rich text field icon',
		description:
			'Accessible label for the icon representing the rich text field in a Jira work item action card.',
	},
});

export function RichTextFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<AlignTextLeftIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
